import React, { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./MetaphorExercisesSection.module.css";

export default function CharacterSection({ premiumPayload = {} }) {
  const { t } = useTranslation("user");
  const exercises = premiumPayload?.actExercises || [];

  return (
    <section className={styles.reportSection}>
      <header className={styles.header}>
        <h3>{t("profile.charTitle")}</h3>
        <p>{t("profile.charSubtitle")}</p>
      </header>
      <div className={styles.topRow}>
        <div className={styles.metaphorBox}>
          <div style={{ marginTop: 8, color: "#6b7280" }}>
            <strong style={{ color: "#000" }}>{t("profile.charText")}</strong>{" "}
            {premiumPayload.chosenCharacter?.label}
            <p>{premiumPayload.chosenCharacter?.description}</p>
          </div>
        </div>

        <div className={styles.exercisesBox}>
          <h4>
            {t("profile.charPractice")}
            {premiumPayload.chosenCharacter?.label}
          </h4>
          {exercises.length === 0 ? (
            <p className={styles.empty}>{t("profile.charNoPractice")}</p>
          ) : (
            <ol className={styles.exList}>
              {exercises.map((ex, i) => (
                <li key={i} className={styles.exItem}>
                  <strong>{ex.title}</strong> — {ex.description}
                </li>
              ))}
            </ol>
          )}
        </div>
      </div>
    </section>
  );
}
